import { Component, OnInit } from '@angular/core';
import { httpService } from '.././service/servicio';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  

  }

}



// WEBPACK FOOTER //
// /Users/usuario/Desktop/duran/duran-web/src/app/menu/menu.component.ts